
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSpeedLowLeft as ObiSpeedLowLeftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-speed-low-left.js';
 
 
 

 
 export const ObiSpeedLowLeft = createComponent({
   react: React,
   tagName: 'obi-speed-low-left',
   elementClass: ObiSpeedLowLeftElement,
   events: {
     
   }
  });
 
 